import axios from "axios";
import { Loading, Notification } from "element-ui";
import router from "@/router";
import { RESTFUL_HOST } from "./host";
import qs from "qs";

/**
 * 拦截器
 */
axios.interceptors.request.use(
  function(config) {
    const token = window.localStorage.getItem("token");
    if (token) {
      config.headers.token = token;
    }
    const companyId = localStorage.getItem("curCompanyId");
    if (companyId) {
      config.headers.companyId = companyId;
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

axios.defaults.withCredentials = true;
export default {
  get: (url, data) => {
    var _url = url;
    if (!url.startsWith("http")) {
      _url = RESTFUL_HOST + url;
    }
    return new Promise((resolve, reject) => {
      let loadingInstance = Loading.service({
        fullscreen: true
      });
      axios
        .get(_url, { params: data })
        .then(response => {
          loadingInstance.close();
          parseResponse(response.data, resolve, reject);
        })
        .catch(response => {
          loadingInstance.close();
          parseResponse(
            { code: "ERROR", message: "网络连接中断，请检查您的网络" },
            null,
            reject
          );
        });
    });
  },
  get2: (url, data) => {
    var _url = url;
    if (!url.startsWith("http")) {
      _url = RESTFUL_HOST + url;
    }
    return new Promise((resolve, reject) => {
      // let loadingInstance = Loading.service({
      //   fullscreen: true
      // });
      axios
        .get(_url, { params: data })
        .then(response => {
          // loadingInstance.close();
          parseResponse(response.data, resolve, reject);
        })
        .catch(response => {
          // loadingInstance.close();
          parseResponse(
            { code: "ERROR", message: "网络连接中断，请检查您的网络" },
            null,
            reject
          );
        });
    });
  },
  post: (url, data) => {
    var _url = url;
    if (!url.startsWith("http")) {
      _url = RESTFUL_HOST + url;
    }
    if (data) {
      //data = JSON.stringify(data);
    }
    return new Promise((resolve, reject) => {
      let loadingInstance = Loading.service({
        fullscreen: true
      });

      axios
        .post(_url, data)
        .then(response => {
          loadingInstance.close();
          parseResponse(response.data, resolve, reject);
        })
        .catch(response => {
          loadingInstance.close();
          parseResponse(
            { code: "ERROR", message: "网络连接中断，请检查您的网络" },
            null,
            reject
          );
        });
    });
  },
  post2: (url, data) => {
    var _url = url;
    if (!url.startsWith("http")) {
      _url = RESTFUL_HOST + url;
    }
    if (data) {
      //data = JSON.stringify(data);
    }
    return new Promise((resolve, reject) => {
      axios
        .post(_url, data)
        .then(response => {
          parseResponse(response.data, resolve, reject);
        })
        .catch(response => {
          parseResponse(
            { code: "ERROR", message: "网络连接中断，请检查您的网络" },
            null,
            reject
          );
        });
    });
  },
  put: (url, data) => {
    var _url = url;
    if (!url.startsWith("http")) {
      _url = RESTFUL_HOST + url;
    }
    if (data) {
      //data = JSON.stringify(data);
    }
    return new Promise((resolve, reject) => {
      let loadingInstance = Loading.service({
        fullscreen: true
      });
      axios
        .put(_url, data)
        .then(response => {
          loadingInstance.close();
          parseResponse(response.data, resolve, reject);
        })
        .catch(response => {
          loadingInstance.close();
          parseResponse(
            { code: "ERROR", message: "网络连接中断，请检查您的网络" },
            null,
            reject
          );
        });
    });
  },
  delete: (url, data) => {
    var _url = url;
    if (!url.startsWith("http")) {
      _url = RESTFUL_HOST + url;
    }
    if (data) {
      //data = JSON.stringify(data);
    }
    return new Promise((resolve, reject) => {
      let loadingInstance = Loading.service({
        fullscreen: true
      });
      axios
        .delete(_url, { data: data })
        .then(response => {
          loadingInstance.close();
          parseResponse(response.data, resolve, reject);
        })
        .catch(response => {
          loadingInstance.close();
          parseResponse(
            { code: "ERROR", message: "网络连接中断，请检查您的网络" },
            null,
            reject
          );
        });
    });
  }
};

function parseResponse(resp, resolve, reject) {
  var { code, message, data } = resp;
  //成功
  if (!code) {
    return resolve(data);
  }
  if ("TOKEN_ERR" == code) {
    return router.push("/");
  } else if ("DISABLE_ERR" == code) {
    // Notification.warning({
    //   title: "系统提示",
    //   message: message,
    //   duration: 2000,
    //   onClose: () => {
    //     router.push("/");
    //   }
    // });
    console.log(message);
    return;
  }
  reject(message);
}



// WEBPACK FOOTER //
// ./src/utils/request.js